import { React } from "react";
import "./Hero.css";

const Hero = () => {
  return (
    <div className="hero">
      <div className="hero-container">
        <h1>Chess Tutor:</h1>
        <h2>Giuoco Precisamente</h2>
      </div>
    </div>
  );
};

export default Hero;
